export default {
  labels: {
    dont_have_account: 'Heb je geen account? ',
  },
  title: 'Word lid van {{name}}!',
  default_program_name: 'Beloningsclub',
  buttons: {
    sign_up: 'Aanmelden',
  },
};
